import axios from "../../plugins/axios";
import pushModel from "../../mixin/store/api/pushModel";
import fetchModels from "../../mixin/store/api/fetchModels";
import changeModel from "../../mixin/store/api/changeModel";
import deleteModel from "../../mixin/store/api/deleteModel";
import fetchModel from "../../mixin/store/api/fetchModel";

export default {
    actions: {
        fetchSales(context, page) {
            return fetchModels(context, 'sales?order[id]=desc', page, 'updateSales');
        },
        fetchRepaymentDateSales(context) {
            return fetchModels(context, 'sales/nearly_paying_debts', null, 'updateNearlyRepayingSale');
        },
        fetchTodaySalesTotalAmount(context) {
            return fetchModel(context, 'sales/today_sales', null, 'updateTodayTotalAmount');
        },
        fetchDraftSales(context, page) {
            return fetchModels(context, 'sales/drafts', page, 'updateDraftSalesDetails');
        },
        fetchSaleServicesTransaction(context, search) {
            return fetchModels(context, 'sales/service_transactions', search.page, 'updateSaleServicesTransactions');
        },
        fetchTodaySaleServiceTotalAmount(context) {
            return fetchModel(context, 'sales/today_sale_service', null, 'updateTodaySaleServiceTotalAmount');
        },
        fetchSaleRefunds(context, search) {
            return fetchModels(context, 'sale_refunds?order[id]=desc', search.page, 'updateRefundSales');
        },
        fetchSaleRefund(context, saleId) {
            return fetchModels(context, 'sale_refunds?sale.id=' + saleId, null, 'updateRefundSale');
        },
        fetchAllSales(context) {
            return fetchModels(context, 'sales?pagination=false&order[id]=desc', null, 'updateAllSales');
        },
        fetchSale(context, id) {
            return fetchModel(context, 'sales', id, 'updateSale');
        },
        fetchCustomerSaleFirstPurchase(context, data) {
            return pushModel(context, 'sales/customer', data, 'updateCustomerFirstPurchase')
        },
        fetchSalesCustomer(context, searchItem) {
            let url = '/sales?page=' + searchItem.page + '&customer.id=' + searchItem.customerId;
            let isSearch = false;

            if (searchItem.after) {
                url = url + '&createdAt[strictly_after]=00:00:00' + searchItem.after
                isSearch = true;
            }

            if (searchItem.isPayed !== null) {
                url = url + '&exists[transaction]=' + searchItem.isPayed
                isSearch = true;
            }

            if (searchItem.startDate) {
                url = url + '&pagination=false&createdAt[before]=' + searchItem.endDate
                isSearch = true;
            }

            if (searchItem.before) {
                url = url + '&createdAt[strictly_before]=23:59:59' + searchItem.before
                isSearch = true;
            }

            if (searchItem.endDate) {
                url = url + '&pagination=false&createdAt[after]=' + searchItem.startDate
                isSearch = true;
            }

            if (searchItem.totalPriceMin) {
                url = url + '&totalPrice[gte]=' + searchItem.totalPriceMin
                isSearch = true;
            }

            if (searchItem.totalPriceMax) {
                url = url + '&totalPrice[lte]=' + searchItem.totalPriceMax
                isSearch = true;
            }

            if (!isSearch) {
                url += "&order[id]=desc"
            }
            return new Promise((resolve, reject) => {
                axios.get(url)
                    .then((response) => {
                        let data = {
                            models: response.data['hydra:member'],
                            totalItems: response.data['hydra:totalItems']
                        }
                        context.commit('updateSales', data)
                        resolve(response.data)
                    })
                    .catch(() => {
                        reject()
                    })

            })
        },
        deleteSale(context, id) {
            return deleteModel(context, 'sales', id)
        },
        searchDraftSales(context, searchItem) {
            let url = "sales/drafts?page=" + searchItem.page;

            if (searchItem.personGivenName) {
                url = url + '&customerGivenName=' + searchItem.personGivenName
            }

            if (searchItem.personFamilyName) {
                url = url + '&customerFamilyName=' + searchItem.personFamilyName
            }

            if (searchItem.customerCompanyName) {
                url = url + '&customerCompanyName=' + searchItem.customerCompanyName
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)
                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }
                    context.commit('updateDraftSales', data)

                })
                .catch((err) => {
                    console.log(err)

                })
        },
        searchSales(context, searchItem) {
            let url = "sales?page=" + searchItem.page + '&isDraft=false';
            let isSearch = false;

            if (searchItem.personGivenName) {
                url = url + '&customer.person.givenName=' + searchItem.personGivenName
                isSearch = true;
            }

            if (searchItem.personFamilyName) {
                url = url + '&customer.person.familyName=' + searchItem.personFamilyName
                isSearch = true;
            }

            if (searchItem.personAdditionalName) {
                url = url + '&customer.person.additionalName=' + searchItem.personAdditionalName
                isSearch = true;
            }

            if (searchItem.companyName) {
                url = url + '&customer.customerCompany.name=' + searchItem.companyName
                isSearch = true;
            }

            if (searchItem.after) {
                url = url + '&createdAt[strictly_after]=00:00:00' + searchItem.after
                isSearch = true;
            }

            if (searchItem.isPayed !== null) {
                url = url + '&exists[transaction]=' + searchItem.isPayed
                isSearch = true;
            }

            if (searchItem.startDate) {
                url = url + '&pagination=false&createdAt[before]=' + searchItem.endDate
                isSearch = true;
            }

            if (searchItem.before) {
                url = url + '&createdAt[strictly_before]=23:59:59' + searchItem.before
                isSearch = true;
            }

            if (searchItem.endDate) {
                url = url + '&pagination=false&createdAt[after]=' + searchItem.startDate
                isSearch = true;
            }

            if (searchItem.sumMin) {
                url = url + '&saleProducts.price[gte]=' + searchItem.sumMin
                isSearch = true;
            }

            if (searchItem.sumMax) {
                url = url + '&saleProducts.price[lte]=' + searchItem.sumMax
                isSearch = true;
            }

            if (!isSearch) {
                url += "&order[id]=desc"
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)

                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updateSales', data)

                })
                .catch((err) => {
                    console.log(err)
                })
        },
        searchSalesTransactions(context, searchItem) {
            let url = "sales/transactions?page=" + searchItem.page + '&isDraft=false';
            let isSearch = false;

            if (searchItem.personGivenName) {
                url = url + '&customer.person.givenName=' + searchItem.personGivenName
                isSearch = true;
            }

            if (searchItem.id !== null) {
                url = url + '&id=' + searchItem.id
                isSearch = true;
            }

            if (searchItem.personFamilyName) {
                url = url + '&customer.person.familyName=' + searchItem.personFamilyName
                isSearch = true;
            }

            if (searchItem.personAdditionalName) {
                url = url + '&customer.person.additionalName=' + searchItem.personAdditionalName
                isSearch = true;
            }

            if (searchItem.companyName) {
                url = url + '&customer.customerCompany.name=' + searchItem.companyName
                isSearch = true;
            }

            if (searchItem.after) {
                url = url + '&createdAt[strictly_after]=00:00:00' + searchItem.after
                isSearch = true;
            }

            if (searchItem.isPayed !== null) {
                url = url + '&exists[transaction]=' + searchItem.isPayed
                isSearch = true;
            }

            if (searchItem.startDate) {
                url = url + '&pagination=false&createdAt[before]=' + searchItem.endDate
                isSearch = true;
            }

            if (searchItem.before) {
                url = url + '&createdAt[strictly_before]=23:59:59' + searchItem.before
                isSearch = true;
            }

            if (searchItem.endDate) {
                url = url + '&pagination=false&createdAt[after]=' + searchItem.startDate
                isSearch = true;
            }

            if (searchItem.sumMin) {
                url = url + '&saleProducts.price[gte]=' + searchItem.sumMin
                isSearch = true;
            }

            if (searchItem.sumMax) {
                url = url + '&saleProducts.price[lte]=' + searchItem.sumMax
                isSearch = true;
            }

            if (!isSearch) {
                url += "&order[id]=desc"
            }

            if (!searchItem.isSearch) {
                url += "&order[id]=desc"
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)

                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updateSales', data)

                })
                .catch((err) => {
                    console.log(err)
                })
        },
        searchStatistics(context, searchItem) {
            let url = "sales/statistics?page=" + searchItem.page + '&isDraft=false';

            if (searchItem.startDate) {
                url = url + '&pagination=false&createdAt[before]=' + searchItem.endDate
            }

            if (searchItem.endDate) {
                url = url + '&pagination=false&createdAt[after]=' + searchItem.startDate
            }

            url += "&order[id]=desc"

            return axios.get(url)
                .then((response) => {
                    console.log(response)

                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updateSales', data)

                })
                .catch((err) => {
                    console.log(err)
                })
        },
        removeSoldOutProductFromProductInWarehouseList({commit, rootState}, piw) {
            commit('removeProduct', {rootState, piw})
        },
        pushSale(context, data) {
            // todo redirect (in pushModel) to url with id

            data.company = context.getters.getUserCompanyIdAt
            data.customer = axios.custom.entityId('customers', data.customerId)

            switch (data.currentCurrency) {
                case 'USD':
                    data.currency = context.getters.getCurrencyByShortName('USD')['@id']
                    break

                case 'RUB':
                    data.currency = context.getters.getCurrencyByShortName('RUB')['@id']
                    break

                case 'UZS':
                    data.currency = context.getters.getCurrencyByShortName('UZS')['@id']
                    break
            }

            for (let i in data.saleProductDtos) {
                // todo do one main currency of sale

                data.saleProductDtos[i].price = data.saleProductDtos[i].sum.toString()
                data.saleProductDtos[i].quantity = (data.saleProductDtos[i].quantity + data.saleProductDtos[i].addQuantity)
                data.saleProductDtos[i].quantity = parseFloat(data.saleProductDtos[i].quantity)
                data.saleProductDtos[i].amount = data.saleProductDtos[i].amount - data.saleProductDtos[i].quantity

                if (data.saleProductDtos[i].amount <= 0) {
                    context
                        .dispatch('removeSoldOutProductFromProductInWarehouseList', data.saleProductDtos[i])
                        .then(() => {
                            // do nothing
                        })
                }
            }

            return pushModel(context, 'sales', data)
        },
        pushMakePayed(context, data) {
            return changeModel(context, 'sales/' + data.id + '/make_payed', data, 'updateSale')
        },
        pushMakeUnPayed(context, data) {
            return changeModel(context, 'sales/' + data.id + '/make_unpayed', data, 'updateSale')
        },
        pushDraftSale(context, data) {
            return changeModel(context, 'sales/' + data.id + '/drafts_update', data, 'updateDraftSales')
        },
        putDraftSale(context, data) {
            return changeModel(context, 'sales/' + data.id, data, 'updateDraftSales')
        },
        pushSaleCancel(context, data) {
            return changeModel(context, 'sales/' + data.id + '/cancel', data, 'updateSale')
        },
        pushSaleRefund(context, data) {
            return changeModel(context, 'sales/' + data.saleId + '/refund', data, 'updateSale')
        },
        fetchUpdateSalePayment(context, data) {
            return changeModel(context, 'sales/' + data.id, data, 'updateSale')
        },
        fetchSaleCustomerDailyStat(context, data) {
            if (!context.state.saleCustomerDailyStat.isNeedFetch) {
                return
            }

            return pushModel(context, 'sales/customer/stat', data, 'updateSaleCustomerDailyStat')
        },
        syncSale(context, data) {
            return pushModel(context, 'sales/sync', data)
        }
    },
    mutations: {
        removeProduct(state, {rootState, piw}) {
            let index = rootState.productsInWarehouses.productsInWarehouses.models.findIndex(item => item === piw)
            rootState.productsInWarehouses.productsInWarehouses.models.splice(index, 1)
        },
        updateAllSales(state, data) {
            state.allSales = data
        },
        updateSales(state, data) {
            state.sales = data
        },
        updateSaleServicesTransactions(state, data) {
            state.saleServices = data
        },
        updateTodayTotalAmount(state, data) {
            state.todayTotalAmount = data
        },
        updateTodaySaleServiceTotalAmount(state, data) {
            state.todayServiceTotalAmount = data
        },
        updateDraftSales(state, data) {
            state.draftSales = data
        },
        updateDraftSalesDetails(state, data) {
            state.draftSales = data
        },
        updateRefundSales(state, data) {
            state.refundSales = data
        },
        updateSale(state, model) {
            state.sale = model
        },
        addInfoToReceipt(state, info) {
            state.info = info
        },
        clearInfoFromReceipt(state) {
            state.info = ''
        },
        updateNewSaleId(state, id) {
            state.newSaleId = id
        },
        updateRefundSale(state, refundSale) {
            state.refundSale = refundSale
        },
        updateNearlyRepayingSale(state, sales) {
            state.nearlyRepayingSales = sales
        },
        updateCustomerFirstPurchase(state, data) {
            state.customerFirstPurchase = data
        },
        updateSaleCustomerDailyStat(state, data) {
            state.saleCustomerDailyStat.hourly = data
            state.saleCustomerDailyStat.isNeedFetch = false
        }
    },
    state: {
        nearlyRepayingSales: {
            models: [],
            totalItems: 0,
        },
        allSales: {
            models: [],
            totalItems: 0,
        },
        sales: {
            models: [],
            totalItems: 0,
        },
        saleServices: {
            models: [],
            totalItems: 0,
        },
        todayTotalAmount: {},
        todayServiceTotalAmount: {},
        draftSales: {
            models: [],
            totalItems: 0,
        },
        refundSales: {
            models: [],
            totalItems: 0,
        },
        refundSale: {
            models: [],
            totalItems: 0,
        },
        sale: {
            "@context": null,
            "@id": null,
            "@type": null,
            id: null,
            totalPrice: '0',
            currency: {
                "@id": null,
                "@type": null,
                id: null,
                shortName: null
            },
            transaction: null,
            customer: {
                "@id": null,
                "@type": null,
                id: null,
                person: {
                    telephone: null
                },
                customerCompany: {
                    "@id": null,
                    "@type": null,
                    id: null,
                    name: null,
                },
                isCompany: null,
            },
            createdAt: null,
            saleProducts: [
                {
                    "@id": null,
                    "@type": null,
                    id: null,
                    product: {
                        "@id": null,
                        "@type": null,
                        id: null,
                        name: null,
                        unitOfMeasure: null,
                    },
                    price: null,
                    amount: null,
                },
                {
                    "@id": null,
                    "@type": null,
                    id: null,
                    product: {
                        "@id": null,
                        "@type": null,
                        id: null,
                        name: null,
                        unitOfMeasure: null,
                    },
                    price: null,
                    amount: null,
                }
            ],
            isCanceled: null,
            payedAmount: '',
            employee: {
                "@id": null,
                "@type": null,
                familyName: null,
                givenName: null,
                telephone: null
            },
            discount: [],
            bonusSumAmount: '0',
            discountPercent: 0,
            bonusPercentAmount: '0',
            saleTaxes: [],
            isTaxInPrice: false,
            company: {
                tin: null
            }
        },
        info: '',
        newSaleId: null,
        customerFirstPurchase: null,
        saleCustomerDailyStat: {
            hourly: [],
            isNeedFetch: true
        }
    },
    getters: {
        getSale(state) {
            return state.sale
        },
        getSales(state) {
            return state.sales.models
        },
        getNewSaleId(state) {
            return state.newSaleId
        },
        getTodaySalesTotalAmount(state) {
            return state.todayTotalAmount
        },
        getTodaySaleServiceTotalAmount(state) {
            return state.todayServiceTotalAmount
        },
        getDraftSales(state) {
            return state.draftSales.models
        },
        getDraftSalesTotalCount(state) {
            return state.draftSales.totalItems
        },
        getSaleServices(state) {
            return state.saleServices.models
        },
        getSaleServicesTotalCount(state) {
            return state.saleServices.totalItems
        },
        getRefundSales(state) {
            return state.refundSales.models
        },
        getRefundSalesTotalCount(state) {
            return state.refundSales.totalItems
        },
        getAllSales(state) {
            return state.allSales.models
        },
        getSalesTotalCount(state) {
            return state.sales.totalItems
        },
        getInfo(state) {
            return state.info
        },
        getRefundSale(state) {
            return state.refundSale.models
        },
        getNearlyRepayingSales(state) {
            return state.nearlyRepayingSales.models
        },
        getCustomerFirstPurchase(state) {
            return state.customerFirstPurchase
        },
        getSaleCustomerDailyStat(state) {
            return state.saleCustomerDailyStat.hourly
        }
    },
}
